import { Link } from 'react-router-dom'
import { SidebarIcon } from '../SideNav/icons'
import usePermission from '../../hooks/usePermission'

interface SideNavItemProps {
  title: string
  icon: string
  isActive?: boolean
  path: string
  collasped?: boolean
  onClick?: () => void
  permissions?: string[]
}

const SideNavItem = ({
  title,
  icon,
  isActive,
  path,
  onClick,
  permissions,
}: SideNavItemProps) => {
  const color = isActive ? 'text-white' : 'text-black'
  const bg = isActive ? 'bg-black' : 'none'

  const { hasPermissions } = usePermission()

  const isPermitted = hasPermissions(permissions)

  const innerItem = (
    <div
      className={`flex items-center w-full my-2 gap-4 rounded-md cursor-pointer ${color} ${bg}`}
      onClick={onClick}
    >
      <div
        className="min-w-10 min-h-10 rounded-lg bg-gray-100 w-10 h-10 m-2"
        style={{ minWidth: '2.5rem' }}
      >
        {<SidebarIcon icon={icon} />}
      </div>
      {<p className={`font-semibold whitespace-nowrap`}>{title}</p>}
    </div>
  )

  const item = path ? <Link to={`${path}`}>{innerItem}</Link> : innerItem

  return isPermitted ? item : null
}

export default SideNavItem
